import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { AdvanceBillPaymentData } from '../../../../../../models/order/workflow/advance-bill-payment.model';



@Injectable({ providedIn: 'root' })
export class AdvanceBillPaymentStateService extends BaseWorkflowStateService<AdvanceBillPaymentData> {
    override stateKey: string = 'advanceBillPayment';
}